var _g, _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFourIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2379_35781)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 35.5,
    stroke: "#FBBC05"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 40,
    r: 29,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 10.9999C45.9773 10.9999 51.3407 12.606 55.9471 15.6291C60.5539 18.6523 64.2092 22.9656 66.47 28.0549C68.731 33.1445 69.4998 38.791 68.6826 44.3161C67.8653 49.841 65.4975 55.0052 61.8676 59.1901C58.2379 63.3746 53.5011 66.4018 48.2278 67.9134C42.9548 69.4249 37.3654 69.358 32.1286 67.7206C26.8916 66.0831 22.2259 62.9431 18.694 58.6724C15.1617 54.4014 12.9142 49.1816 12.2252 43.6385",
    stroke: "#FBBC05",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3126 48.0955V44.6189H32.4026L32.1226 42.3555L39.7292 32.0655H43.2059V42.1222H45.4226V44.6189H43.2059V48.0955H40.3126ZM35.2259 42.1222H40.3126V35.2389L35.2259 42.1222Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2379_35781",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2379_35781"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourIcon);
export default __webpack_public_path__ + "static/media/four_icon.114d9e57a51c3caea414de539396b390.svg";
export { ForwardRef as ReactComponent };